<template>
  <div :class="componentClassName">
    <a-page-heading :id="idName">着信フロー設定</a-page-heading>
    <a-select-field
      v-if="companyID === POINT && companyIDList.length !== 0"
      id="-companyId"
      v-model="selectedCompanyID"
      :options="companyIDList"
      :searchable="true"
    />
    <m-section
      :class="{
        't-setting-ivr-list__section-ivr': setting.is_ivr,
      }"
    >
      <m-action-card :custom-header="true" icon="phone-setting" :header-border="true">
        <template #customTitle>
          <a-select-field id="callFlowList" v-model="selectedCallFlow" :options="callFlowList" :searchable="true" />
        </template>
        <template v-if="setting.has_setting && setting.is_ivr">
          <div class="t-setting-ivr-list__row">
            <m-response-flow-summary
              class="t-setting-ivr-list__col t-setting-ivr-list-response-flow"
              title="分岐ごとの応答内容設定"
              :list="setting.flows"
            />
            <a-application-summary-item class="t-setting-ivr-list__col" title="自動音声ガイダンス">
              <!--                <a-text class="t-setting-ivr-list-voice-guidance__text">{{ setting.voice_guidance.voice }}</a-text>-->
              <a-text id="guidanceText" class="t-setting-ivr-list-voice-guidance__text">{{
                setting.voice_guidance.message
              }}</a-text>
              <!--                <a-button-->
              <!--                  class="t-setting-ivr-list-voice-guidance__button"-->
              <!--                  color="primary"-->
              <!--                  variant="fill"-->
              <!--                  label="テスト再生"-->
              <!--                  icon="play"-->
              <!--                  size="small"-->
              <!--                  @click="handleVoiceGuidanceClick(index)"-->
              <!--                />-->
            </a-application-summary-item>
            <!-- <a-application-summary-item class="t-setting-ivr-list__col" title="メール通知先" v-if="setting.mailFlag">
              <a-text class="t-setting-ivr-list-voice-guidance__text">{{ setting.absenceMail }}</a-text>
            </a-application-summary-item> -->
          </div>
        </template>
        <template
          v-if="setting.has_setting && !setting.is_ivr && setting.respond && setting.respond.mode === 'transfer'"
        >
          <m-data-list variant="long" :data="[{ label: '外線転送', content: setting.respond.phone_number }]" />
        </template>
        <template
          v-if="setting.has_setting && !setting.is_ivr && setting.respond && setting.respond.mode === 'voiceDX'"
        >
          <m-data-list
            variant="long"
            :data="[{ label: 'COTOHA Voice DX Basic', content: setting.respond.voiceDXNumberName }]"
          />
        </template>
        <template v-if="setting.has_setting && !setting.is_ivr && setting.respond && setting.respond.mode === 'user'">
          <m-data-list
            id="groupName"
            variant="long"
            :data="[{ label: 'グループに一斉着信', content: setting.respond.group_name }]"
          />
        </template>
        <template v-if="!setting.has_setting">
          <m-data-list variant="long" :data="[{ label: '設定なし' }]" />
        </template>
        <div v-if="canEditCallFlow" class="m-action-card__footer-actions">
          <a-button
            id="edit"
            variant="fill"
            size="small"
            icon="edit"
            color="grey"
            :label="editButtonLabel"
            @click="gotoEditPage(selectedCallFlow)"
          />
        </div>
      </m-action-card>
    </m-section>
  </div>
  <!-- Info, Erro Modal -->
  <teleport to="body">
    <o-modal
      id="settingIvrList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button id="closeModal" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataList from '@/components/molecules/data-list';
import MResponseFlowSummary from '@/components/molecules/response-flow-summary';
import AApplicationSummaryItem from '@/components/atoms/application-summary-item';
import * as Handlebars from 'handlebars';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import { POINT } from '@/libs/constants';

// For Trial
import { utils } from '@/common/utils.js';
import { TRIALPHONENUMBER } from '@/libs/constants';

export default {
  name: 't-setting-ivr-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MDataList,
    AText,
    MResponseFlowSummary,
    AApplicationSummaryItem,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    handleSettingClick: {
      type: Function,
      default: () => {},
    },
    handleVoiceGuidanceClick: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      setting: {},
      settings: {},
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      selectedCompanyID: '',
      companyIDList: [],
      authInfo: this.$store.state.user.authInfo,
      POINT,
      isTrialCompanyID: false,
      titleTextTrial: messageContent.titleTextTrial(),
      idName: 'h1-call-flow',
      callFlowList: [],
      selectedCallFlow: '',
      settingLoaded: null,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-ivr-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    isGeneralOperator() {
      return this.companyID !== POINT && this.authInfo === 'operator';
    },
    isCOMOperator() {
      return this.companyID === POINT && this.authInfo === 'operator';
    },
    editButtonLabel() {
      return this.isCOMOperator ? '参照' : '編集';
    },
    canEditCallFlow() {
      return PERMISSIONS_FRONTEND['CallFlowEdit'][this.authInfo] && !this.isGeneralOperator;
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
        }
        await this.loadSettings();
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
    },
    selectedCallFlow(val) {
      this.setting = this.settings[val];
    },
    settingLoaded(val) {
      this.setLoading(!val);
    },
  },
  async created() {
    this.settingLoaded = false;
    if (this.companyID === POINT) {
      await this.fetchCompanyIDListHandler();
    }
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
  },
  methods: {
    loadSettings: async function () {
      this.settingLoaded = false;
      const tmpCompanyID = this.companyID === POINT ? this.$route.query.companyID : this.companyID;
      // For Trial
      if (utils.chkTrialCompanyID(tmpCompanyID)) {
        this.isTrialCompanyID = true;
        const tmpCallFlowName = `${tmpCompanyID}_${TRIALPHONENUMBER}`;
        this.settings = {};
        this.settings[tmpCallFlowName] = {
          has_setting: true,
          phone_number: `${TRIALPHONENUMBER}`,
          is_ivr: false,
          respond: {
            mode: 'user',
            group_name: 'default',
          },
        };
        this.loadCallFlowList();
      } else {
        this.isTrialCompanyID = false;
        await this.postRequest('/callflow', {
          companyID: tmpCompanyID,
        })
          .then(res => {
            this.settings = res.data;
            this.loadCallFlowList();
          })
          .catch(err => {
            console.log(err);
            this.showErrorModal(messageContent.requireTry('検索'));
          });
      }
      const callFlowName = this.$route.params.callFlowName;
      this.selectedCallFlow =
        callFlowName && this.settings[callFlowName] ? callFlowName : Object.keys(this.settings)[0];
      this.settingLoaded = true;
    },
    loadCallFlowList: function () {
      this.callFlowList = [];
      for (const callFlowName in this.settings) {
        const label = this.isTrialCompanyID
          ? this.titleTextTrial
          : `${this.settings[callFlowName].numberName}（${this.settings[callFlowName].phone_number}）`;
        this.callFlowList.push({ label, value: callFlowName });
      }
    },
    fetchCompanyIDListHandler: async function () {
      await this.postRequest('/companymgmt/getcompanyidlistCCCOnly', { withPoint: true })
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('登録ユーザーの取得'));
        });
    },
    gotoEditPage: function (cfn) {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'CallFlowEdit',
          params: { callFlowName: cfn },
          query: { companyID: this.$route.query.companyID },
        });
      } else {
        this.$router.push({ name: 'CallFlowEdit', params: { callFlowName: cfn } });
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
